import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "widget-header row items-center q-px-md justify-between" }
const _hoisted_2 = { class: "text-weight-bold text-body1" }
const _hoisted_3 = { class: "buttons-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.isWidgetOpenedAtPhoneScreen)
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 0,
            flat: true,
            dense: true,
            icon: _ctx.popupOpened ? 'filter_none' : 'crop_din',
            class: "q-mr-md",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('toggle-popup')), ["stop"]))
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true),
      _createVNode(_component_q_btn, {
        flat: true,
        dense: true,
        icon: "close",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('close-popup')), ["stop"]))
      })
    ]),
    _createElementVNode("div", {
      style: _normalizeStyle({ ..._ctx.background }),
      class: _normalizeClass(["background", { 'bg-primary': _ctx.usePrimaryColorAsBackground }])
    }, null, 6)
  ]))
}